export const translations = {
  en: {
    title: "Total Energy Use Calculator",
    pickLocation: "Pick your location",
    state: "State",
    selectDevices: "Select your appliances and devices",
    addDevice: "Add new device",
    numberOfUnits: "Number of Units",
    averageHoursPerWeek: "Average Hours Per Week",
    estimatedBill: "Your estimated monthly bill",
    estimatedKwh: "Estimated Total Monthly kWh",
    estimatedPrice: "Estimated Energy Price",
    startOver: "Start over",
    calculate: "Calculate total cost",
    fullTimeHelp: "This unit operates 24 hours a day",
    privacyPolicy: "Privacy Policy",
    privacyPolicyUrl: "https://paylesspower.com/privacy-policy/",
    logoAlt: "Payless Power Logo",
  },
  es: {
    title: "Calculadora de consumo total de energía",
    pickLocation: "Elige tu ubicación",
    state: "Estado",
    selectDevices: "Selecciona tus electrodomésticos y dispositivos",
    addDevice: "Agregar un dispositivo nuevo",
    numberOfUnits: "Número de unidades",
    averageHoursPerWeek: "Promedio de horas por semana",
    estimatedBill: "Tu factura mensual estimada",
    estimatedKwh: "Total mensual estimado de kWh",
    estimatedPrice: "Precio estimado de energía",
    startOver: "Empezar de nuevo",
    calculate: "Calcular el costo total",
    fullTimeHelp: "Esta unidad funciona las 24 horas del día",
    privacyPolicy: "Política de privacidad",
    privacyPolicyUrl: "https://paylesspower.com/es/privacy-policy/",
    logoAlt: "Logo de Payless Power",
  },
};

export const categoryTranslations = {
  "Cooling And Heating": "Aire acondicionado y calefacción",
  Appliances: "Electrodomésticos",
  Lighting: "Iluminación",
};

export const deviceTranslations = {
  "Central Air Conditioner": "Aire acondicionado central",
  "Window Air Conditioner": "Aire acondicionado de ventana",
  Furnace: "Calefactor",
  "Heat Pump": "Bomba de calor",
  "Portable Heater": "Calentador portátil",
  "Ceiling Fans": "Ventiladores de techo",
  "Electric Water Heater": "Calentador de agua eléctrico",
  Refrigerator: "Refrigerador",
  Freezer: "Congelador",
  Stove: "Estufa",
  Oven: "Horno",
  "Microwave Oven": "Horno de microondas",
  Dishwasher: "Lavavajillas",
  "Clothes Washer": "Lavadora",
  "Clothes Dryer": "Secadora",
  "Clothes Iron": "Plancha",
  Television: "Televisor",
  "Desktop Computer and Monitor": "Computadora de escritorio y monitor",
  "Laptop Computer": "Computadora portátil",
  Printer: "Impresora",
  "Game Console": "Consola de videojuegos",
  "Coffee Maker": "Cafetera",
  Toaster: "Tostadora",
  Blender: "Licuadora",
  "Hair Dryer": "Secador de cabello",
  "Home Security System": "Sistema de seguridad para el hogar",
  "LED Bulbs": "Bombillas LED",
  "Incandescent Bulbs": "Bombillas incandescentes",
};

export const stateTranslations = {
  Alabama: "Alabama",
  Alaska: "Alaska",
  Arizona: "Arizona",
  Arkansas: "Arkansas",
  California: "California",
  Colorado: "Colorado",
  Connecticut: "Connecticut",
  "District of Columbia": "Distrito de Columbia",
  Delaware: "Delaware",
  Florida: "Florida",
  Georgia: "Georgia",
  Hawaii: "Hawái",
  Idaho: "Idaho",
  Illinois: "Illinois",
  Indiana: "Indiana",
  Iowa: "Iowa",
  Kansas: "Kansas",
  Kentucky: "Kentucky",
  Louisiana: "Luisiana",
  Maine: "Maine",
  Maryland: "Maryland",
  Massachusetts: "Massachusetts",
  Michigan: "Míchigan",
  Minnesota: "Minnesota",
  Mississippi: "Misisipi",
  Missouri: "Misuri",
  Montana: "Montana",
  Nebraska: "Nebraska",
  Nevada: "Nevada",
  "New Hampshire": "Nuevo Hampshire",
  "New Jersey": "Nueva Jersey",
  "New Mexico": "Nuevo México",
  "New York": "Nueva York",
  "North Carolina": "Carolina del Norte",
  "North Dakota": "Dakota del Norte",
  Ohio: "Ohio",
  Oklahoma: "Oklahoma",
  Oregon: "Oregón",
  Pennsylvania: "Pensilvania",
  "Rhode Island": "Rhode Island",
  "South Carolina": "Carolina del Sur",
  "South Dakota": "Dakota del Sur",
  Tennessee: "Tennessee",
  Texas: "Texas",
  Utah: "Utah",
  Vermont: "Vermont",
  Virginia: "Virginia",
  Washington: "Washington",
  "West Virginia": "Virginia Occidental",
  Wisconsin: "Wisconsin",
  Wyoming: "Wyoming",
};

export const getLocale = () => {
  const requestedLocale = new URLSearchParams(window.location.search).get("lang");
  const documentLocale = document.documentElement.lang;

  return requestedLocale === "es" || documentLocale.toLowerCase().startsWith("es")
    ? "es"
    : "en";
};
